/**
 * Determines if the provided input signifies that a user has been invited.
 *
 * This function checks if the given parameter is a string and whether it
 * includes the substring '/accept-invite', ignoring case sensitivity.
 *
 * @param {unknown} param - The input to be evaluated.
 *
 * @returns {boolean} Returns true if `param` is a string that includes the
 *   substring '/accept-invite' (case insensitive), otherwise returns false.
 */
export const getIsUserInvited = (param: unknown) => {
  if (typeof param !== 'string') return false

  return param.toLocaleLowerCase().includes('/accept-invite')
}
